import {
    confirmDialog,
    ConfirmDialogAppendToType,
    ConfirmDialogOptions,
    ConfirmDialogReturn,
} from 'primereact/confirmdialog'
import React from 'react'
import { LuxHeading } from '../Techedge-Wardrobe'

export default class AlertDialogBuilder {
    private readonly _dialog: ConfirmDialogOptions

    constructor() {
        this._dialog = {
            message: '',
            accept: undefined,
            reject: undefined,
            acceptClassName: 'wardrobe-button',
            rejectClassName: 'wardrobe-button p-button-secondary',
            rejectLabel: undefined,
            acceptLabel: 'Confirm',
            element: undefined,
            props: undefined,
        }
    }

    public setMessage = (message: string) => {
        this._dialog.message = message
        return this
    }

    public setAccept = (
        acceptLabel: string,
        accept: any,
        acceptClassName?: string
    ) => {
        this._dialog.acceptLabel = acceptLabel
        this._dialog.accept = accept
        this._dialog.acceptClassName = acceptClassName
            ? acceptClassName
            : undefined
        return this
    }
    public setReject = (
        rejectLabel: string,
        reject: any,
        rejectClassName?: string
    ) => {
        this._dialog.rejectLabel = rejectLabel
        this._dialog.reject = reject
        this._dialog.rejectClassName = rejectClassName
            ? rejectClassName
            : undefined
        return this
    }

    public setLockBackground = (lockBackground: boolean = true) => {
        this._dialog.modal = lockBackground
        return this
    }

    public setBlockScroll = (blockScroll: boolean = true) => {
        this._dialog.blockScroll = blockScroll
        return this
    }

    public setHeader = (header: React.ReactNode) => {
        this._dialog.header = header
        return this
    }

    public setFooter = (footer: React.ReactNode) => {
        this._dialog.footer = footer
        return this
    }

    public setIcon = (icon: any) => {
        this._dialog.icon = icon
        return this
    }

    public setOnHide = (onHide: () => void) => {
        this._dialog.onHide = onHide
        return this
    }

    public setAppendTo = (appendTo: ConfirmDialogAppendToType) => {
        this._dialog.appendTo = appendTo
        return this
    }

    public setAppendToBody = () => {
        this._dialog.appendTo = document.body
        return this
    }

    public setClosable = (closable: boolean) => {
        this._dialog.closable = closable
        // console.log('fabio')
        return this
    }

    public setDraggable = (draggable: boolean) => {
        this._dialog.draggable = draggable
        return this
    }

    public build = (): ConfirmDialogReturn => {
        this._dialog.acceptClassName = 'wardrobe-button'
        this._dialog.rejectClassName =
            'wardrobe-button p-button-secondary p-button-outlined'
        return confirmDialog(this._dialog)
    }

    public static deleteDialog = (
        accept: any,
        message: string,
        closable: boolean,
        acceptLabel: string = 'Ok',
        reject?: any,
        rejectLabel: string = 'Cancel'
    ): ConfirmDialogReturn => {
        return AlertDialogBuilder.dialog(accept, message, closable, 'Warning')
    }

    public static dialog = (
        accept: any,
        message: string,
        closable: boolean,
        header: string,
        acceptLabel: string = 'Ok',
        reject?: any,
        rejectLabel: string = 'Cancel',
        draggable?: boolean
    ): ConfirmDialogReturn => {
        return new AlertDialogBuilder()
            .setHeader(
                <LuxHeading type="h1" classes={'dialog-header-title'}>
                    {header}
                </LuxHeading>
            )
            .setMessage(message)
            .setClosable(closable)
            .setDraggable(draggable)
            .setAccept(acceptLabel, accept)
            .setReject(rejectLabel, reject)
            .setAppendToBody()
            .build()
    }
}
